import React from 'react';

const AllESports = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.50299 4.7929C4.56967 4.7929 3.77837 5.47919 3.64638 6.40313L2.5831 13.8461C2.48011 14.5671 3.03954 15.2121 3.76781 15.2121C4.25717 15.2121 4.69722 14.9142 4.87896 14.4598L5.77005 12.2321C4.9681 12.0192 4.37714 11.2882 4.37714 10.4193C4.37714 9.38351 5.2168 8.54384 6.25259 8.54384C7.28837 8.54384 8.12804 9.38351 8.12804 10.4193C8.12804 10.6385 8.09044 10.8489 8.02133 11.0444H11.9845C11.9154 10.8489 11.8778 10.6385 11.8778 10.4193C11.8778 9.38351 12.7174 8.54384 13.7532 8.54384C14.789 8.54384 15.6287 9.38351 15.6287 10.4193C15.6287 11.2885 15.0374 12.0196 14.235 12.2323L15.126 14.4598C15.3078 14.9142 15.7478 15.2121 16.2372 15.2121C16.9655 15.2121 17.5249 14.5671 17.4219 13.8461L16.3586 6.40313C16.2266 5.47919 15.4353 4.7929 14.502 4.7929H5.50299ZM2.40865 6.22631C2.62863 4.68641 3.94745 3.5426 5.50299 3.5426H14.502C16.0575 3.5426 17.3764 4.68641 17.5964 6.22631L18.6596 13.6693C18.8702 15.1435 17.7263 16.4624 16.2372 16.4624C15.2366 16.4624 14.3368 15.8532 13.9652 14.9242L12.9134 12.2947H7.09161L6.03983 14.9242C5.66822 15.8532 4.76842 16.4624 3.76781 16.4624C2.27867 16.4624 1.13477 15.1435 1.34537 13.6693L2.40865 6.22631ZM6.25259 9.79414C5.90733 9.79414 5.62744 10.074 5.62744 10.4193C5.62744 10.7646 5.90733 11.0444 6.25259 11.0444C6.59785 11.0444 6.87774 10.7646 6.87774 10.4193C6.87774 10.074 6.59785 9.79414 6.25259 9.79414ZM13.1281 10.4193C13.1281 10.074 13.408 9.79414 13.7532 9.79414C14.0985 9.79414 14.3784 10.074 14.3784 10.4193C14.3784 10.7646 14.0985 11.0444 13.7532 11.0444C13.408 11.0444 13.1281 10.7646 13.1281 10.4193Z",
      fill: "white"
    }
  )
);

export { AllESports };
//# sourceMappingURL=AllESports.js.map
